var map = {
	"./accounting/en.json": "IkBD",
	"./accounting/fr.json": "QBFw",
	"./claims/en.json": "hdl+",
	"./claims/fr.json": "ROTR",
	"./common/en.json": "DxmK",
	"./common/fr.json": "aG6Z",
	"./dashboard/en.json": "Vv/e",
	"./dashboard/fr.json": "bDAA",
	"./en.json": "JxAT",
	"./equipments/en.json": "jDhz",
	"./equipments/fr.json": "8zVP",
	"./masters/en.json": "4ap1",
	"./masters/fr.json": "irhS",
	"./orders/en.json": "UGjV",
	"./orders/fr.json": "F0e/",
	"./reports/en.json": "ZpMc",
	"./reports/fr.json": "kKqp",
	"./rma/en.json": "NAUj",
	"./rma/fr.json": "OkWW",
	"./servicetickets/en.json": "07Nn",
	"./servicetickets/fr.json": "0RgM",
	"./shared/en.json": "mIN7",
	"./shared/fr.json": "qx1m",
	"./technicaldocumentation/en.json": "GzPh",
	"./technicaldocumentation/fr.json": "gqzI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7eYv";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/locales [A-Za-z0-9-_,\s]+\.json$/
// module id = 7eYv
// module chunks = 1